(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const dialog = document.querySelector('[data-cart-drawer]');
  if (!dialog) return;
  const ui = JSON.parse(document.querySelector('[data-cart-config]').textContent);
  const items = dialog.querySelector('[data-cart-items]');
  const empty = dialog.querySelector('[data-cart-empty]');
  const footer = dialog.querySelector('[data-cart-footer]');
  const error = dialog.querySelector('[data-cart-error]');
  const checkout = dialog.querySelector('[name="checkout"]');
  const timer = dialog.querySelector('[data-cart-timer]');
  const template = document.querySelector('[data-cart-item-template]');
  const timerKey = 'rock-advent-cart-deadline-v1';
  let busy = false, cart = null, restoreFocus = null, deadline = 0, quantityDebounce;
  try { deadline = Number(sessionStorage.getItem(timerKey)) || 0; } catch (_) {}
  function storeDeadline(value) {
    deadline = value;
    try { if (value) sessionStorage.setItem(timerKey, String(value)); else sessionStorage.removeItem(timerKey); } catch (_) {}
  }
  function tick() {
    if (!deadline || !cart || !cart.item_count || !ui.timerEnabled) return;
    const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    timer.querySelector('[data-cart-countdown]').textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    timer.querySelector('[data-cart-timer-label]').textContent = seconds ? ui.reserved : ui.timerEnded;
    timer.classList.toggle('is-expired', seconds === 0);
  }
  function openDrawer(trigger) {
    if (dialog.open) return;
    restoreFocus = trigger || document.activeElement;
    dialog.showModal();
    document.body.classList.add('cart-is-open');
    tick();
  }
  function setBusy(value) {
    busy = value;
    dialog.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('[data-cart-change], [data-cart-quantity], [data-cart-refresh]').forEach(el => { el.disabled = value; });
    checkout.disabled = value || !cart || !cart.item_count;
    document.querySelectorAll('[data-rp-atc]').forEach(button => { button.disabled = value || button.dataset.available === 'false'; });
  }
  function showError(message) {
    error.querySelector('[data-cart-error-message]').textContent = message;
    error.hidden = false;
  }
  async function request(url, options = {}) {
    const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', ...options, headers: {Accept: 'application/json', ...options.headers}, signal: AbortSignal.timeout(20000)});
    let data;
    try { data = await response.json(); } catch (_) { throw new Error(ui.networkError); }
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : ui.networkError);
    return data;
  }
  function money(amount) {
    return new Intl.NumberFormat(ui.locale || 'en', {style: 'currency', currency: cart && cart.currency || ui.currency}).format(amount / 100);
  }
  function render(nextCart) {
    cart = nextCart;
    items.replaceChildren();
    cart.items.forEach(item => {
      const fragment = template.content.cloneNode(true);
      const row = fragment.querySelector('[data-cart-item]');
      row.dataset.key = item.key;
      row.querySelector('[data-cart-item-title]').textContent = item.product_title || item.title;
      row.querySelectorAll('[data-cart-item-link]').forEach(link => { link.href = item.url; });
      const image = row.querySelector('img');
      const src = item.featured_image && item.featured_image.url || item.image;
      if (src) { image.src = src; image.alt = item.product_title || item.title; } else image.hidden = true;
      const variant = row.querySelector('[data-cart-item-variant]');
      variant.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      variant.hidden = !variant.textContent;
      row.querySelector('[data-cart-item-price]').textContent = money(item.final_line_price);
      const compare = row.querySelector('[data-cart-item-compare]');
      compare.hidden = item.original_line_price <= item.final_line_price;
      compare.textContent = compare.hidden ? '' : money(item.original_line_price);
      const quantity = row.querySelector('[data-cart-quantity]');
      quantity.value = item.quantity;
      quantity.setAttribute('aria-label', ui.quantity + ': ' + (item.product_title || item.title));
      row.querySelector('[data-cart-change="minus"]').setAttribute('aria-label', ui.decrease + ': ' + item.product_title);
      row.querySelector('[data-cart-change="plus"]').setAttribute('aria-label', ui.increase + ': ' + item.product_title);
      row.querySelector('[data-cart-change="remove"]').setAttribute('aria-label', ui.remove + ': ' + item.product_title);
      const discounts = row.querySelector('[data-cart-item-discounts]');
      (item.line_level_discount_allocations || []).forEach(discount => {
        const text = document.createElement('span');
        text.textContent = discount.discount_application.title;
        discounts.append(text);
      });
      items.append(fragment);
    });
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
    dialog.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
    const discounts = dialog.querySelector('[data-cart-discounts]');
    discounts.replaceChildren();
    (cart.cart_level_discount_applications || []).forEach(discount => {
      const row = document.createElement('p'), name = document.createElement('span'), value = document.createElement('span');
      name.textContent = discount.title;
      value.textContent = '−' + money(discount.total_allocated_amount);
      row.append(name, value);
      discounts.append(row);
    });
    empty.hidden = cart.item_count > 0;
    footer.hidden = cart.item_count === 0;
    timer.hidden = !ui.timerEnabled || cart.item_count === 0;
    if (!cart.item_count) storeDeadline(0); else if (!deadline) storeDeadline(Date.now() + 300000);
    error.hidden = true;
    tick();
  }
  async function refresh(trigger) {
    if (busy) { openDrawer(trigger); return; }
    openDrawer(trigger);
    setBusy(true);
    dialog.querySelector('[data-cart-loading]').hidden = Boolean(cart);
    try { render(await request(ui.cartUrl)); }
    catch (problem) { showError(problem.message || ui.networkError); }
    finally { dialog.querySelector('[data-cart-loading]').hidden = true; setBusy(false); }
  }
  async function add(form) {
    if (busy) return;
    const root = form.closest('[data-rp-root]'), button = form.querySelector('[data-rp-atc]'), status = form.querySelector('[data-rp-status]');
    if (!button || button.dataset.available === 'false') return;
    const data = new FormData(form), id = data.get('id'), quantity = Number(data.get('quantity') || 1);
    if (!id || !Number.isInteger(quantity) || quantity < 1) { status.textContent = root.dataset.errorLabel; status.dataset.state = 'error'; return; }
    const properties = {};
    if (quantity === 2) properties['Skip The Line'] = 'Included';
    if (quantity === 3) { properties['Skip The Line'] = 'Included'; properties['Mystery Gift (Up To $70)'] = 'Included'; }
    const payload = {items: [{id: Number(id), quantity, properties}]};
    if (quantity === 1) {
      form.querySelectorAll('[data-rp-addon-check]:checked').forEach(input => {
        const addonId = Number(input.value);
        if (addonId) payload.items.push({id: addonId, quantity: 1});
      });
    }
    setBusy(true);
    status.textContent = '';
    status.dataset.state = '';
    button.textContent = root.dataset.addingLabel;
    let added = false;
    try {
      await request(ui.addUrl, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(payload)});
      added = true;
      openDrawer(button);
      dialog.querySelector('[data-cart-loading]').hidden = Boolean(cart);
      render(await request(ui.cartUrl));
      status.textContent = root.dataset.addedLabel;
    } catch (problem) {
      status.dataset.state = 'error';
      status.textContent = added ? ui.addedRefreshError : problem.message || ui.networkError;
      if (added) showError(ui.addedRefreshError);
    } finally {
      dialog.querySelector('[data-cart-loading]').hidden = true;
      setBusy(false);
      button.textContent = root.dataset.addLabel;
    }
  }
  async function change(row, quantity, focusAction) {
    if (busy || !row || !Number.isInteger(quantity) || quantity < 0) return;
    const key = row.dataset.key;
    setBusy(true);
    try {
      render(await request(ui.changeUrl, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: key, quantity})}));
      setBusy(false);
      const newRow = Array.from(items.querySelectorAll('[data-cart-item]')).find(item => item.dataset.key === key);
      if (newRow && focusAction) newRow.querySelector('[data-cart-change="' + focusAction + '"]')?.focus();
      else dialog.querySelector('[data-cart-close]').focus();
    } catch (problem) {
      const message = problem.message || ui.networkError;
      try { render(await request(ui.cartUrl)); } catch (_) {}
      showError(message);
    } finally { setBusy(false); }
  }
  document.addEventListener('submit', event => {
    if (!event.target.matches('.rp-form')) return;
    event.preventDefault();
    add(event.target);
  }, true);
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-cart-open]');
    if (open && !event.ctrlKey && !event.metaKey && !event.shiftKey) { event.preventDefault(); refresh(open); return; }
    if (event.target.closest('[data-cart-close]')) { dialog.close(); return; }
    if (event.target.closest('[data-cart-refresh]')) { refresh(event.target); return; }
    const changeButton = event.target.closest('[data-cart-change]');
    if (changeButton) {
      const row = changeButton.closest('[data-cart-item]'), action = changeButton.dataset.cartChange, current = Number(row.querySelector('[data-cart-quantity]').value);
      change(row, action === 'remove' ? 0 : Math.max(0, current + (action === 'plus' ? 1 : -1)), action);
      return;
    }
    const thumb = event.target.closest('[data-rp-thumb]');
    if (thumb) {
      const root = thumb.closest('[data-rp-root]'), main = root.querySelector('[data-rp-main-image]');
      main.removeAttribute('srcset');
      main.src = thumb.dataset.src;
      root.querySelectorAll('[data-rp-thumb]').forEach(item => { item.classList.toggle('is-active', item === thumb); item.setAttribute('aria-pressed', String(item === thumb)); });
    }
  });
  function commitQuantity(target) {
    clearTimeout(quantityDebounce);
    if (!target.isConnected) return;
    const quantity = Number(target.value);
    if (target.value === '' || !Number.isInteger(quantity) || quantity < 0) { showError(ui.quantityError); checkout.disabled = true; return; }
    change(target.closest('[data-cart-item]'), quantity);
  }
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-cart-quantity]')) return;
    clearTimeout(quantityDebounce);
    quantityDebounce = setTimeout(() => commitQuantity(event.target), 450);
  }, true);
  document.addEventListener('change', event => {
    const target = event.target;
    if (target.matches('[data-cart-quantity]')) {
      commitQuantity(target);
      return;
    }
    if (target.matches('[data-rp-bundle-radio]')) target.closest('[data-rp-root]').querySelectorAll('[data-rp-bundle]').forEach(row => row.classList.toggle('is-selected', row.querySelector('input').checked));
    if (!target.matches('[data-rp-variant-select]')) return;
    const root = target.closest('[data-rp-root]'), option = target.options[target.selectedIndex];
    root.querySelector('[data-rp-price]').textContent = option.dataset.price || '';
    root.querySelector('[data-rp-compare]').textContent = option.dataset.compare || '';
    for (let i = 1; i <= 3; i++) {
      root.querySelector('[data-rp-total="' + i + '"]').textContent = option.getAttribute('data-total-' + i) || '';
      root.querySelector('[data-rp-total-compare="' + i + '"]').textContent = option.getAttribute('data-compare-' + i) || '';
    }
    const button = root.querySelector('[data-rp-atc]');
    button.dataset.available = option.dataset.available;
    button.disabled = busy || option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? root.dataset.addLabel : root.dataset.soldLabel;
  }, true);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { document.body.classList.remove('cart-is-open'); if (restoreFocus && restoreFocus.isConnected) restoreFocus.focus(); });
  document.addEventListener('visibilitychange', tick);
  window.addEventListener('pageshow', () => { if (dialog.open) refresh(); });
  setInterval(tick, 1000);
})();
